module.exports = __webpack_public_path__ + "img/password_change.d63275d4.svg";